import { useState } from "react"
import { BotMessageSquare } from "lucide-react"
import HowItWorksModal from "../how-it-works-modal"
import { LinkBtn } from "../buttons"

const NoConversationMsg = () => {
  const [showHowItWorksModal, setShowHowItWorksModal] = useState(false)

  const toggleModal = () => {
    setShowHowItWorksModal(!showHowItWorksModal)
  }

  return (
    <div className="h-full flex flex-col items-center justify-center bg-neutral-50 w-full">
      <BotMessageSquare aria-hidden="true" size={40} />
      <p className="font-bold text-xl mt-3">No conversations yet</p>
      <p className="mt-3 text-center">
        <LinkBtn text="base" paddingOff onClick={toggleModal}>
          Watch this video
        </LinkBtn>{" "}
        to learn about this feature or <br />
        email{" "}
        <a href="mailto:support@bankingbridge.com" className="underline">
          support@bankingbridge.com
        </a>{" "}
        to enable SMS.
      </p>

      <HowItWorksModal
        videoType="conversations"
        show={showHowItWorksModal}
        toggleModal={toggleModal}
      />
    </div>
  )
}

export default NoConversationMsg
